import { BCButton, BCLoading, BCModal, IButtonClickEventArgs } from '@bimser/components';
import { isValidJSON, MLHelper } from '@bimser/core';
import IconCloseWindow from '@bimser/icons/16/close-window';
import IconWaffle from '@bimser/icons/16/waffle';
import classNames from 'classnames/bind';
import React from 'react';
import Styles from '../assets/style.scss';
import ILeftMenuEBA6IntegrationProps from '../entities/ILeftMenuEBA6IntegrationProps';
const cx = classNames.bind(Styles);

const LeftMenuEBA6Integration = (props: ILeftMenuEBA6IntegrationProps) => {
	const onOkClick = () => {
		props.onOkClick({
			id: props.id
		});
	};

	const onCancelClick = () => {
		props.onCancelClick(props.id);
	};

	const iframeOnLoad = (e: any) => {
		props.setEBA6IntegrationLoading(false);
	};

	const onClickSynergyMenuButton = (args: IButtonClickEventArgs) => {
		props.toggleSider();
	};

	const getPanelTitleValue = () => {
		const json = isValidJSON(props.header);
		if (json) {
			return MLHelper.getMLText(json);
		} else {
			return props.header || 'eBA';
		}
	};

	const getPanelHeader = () => {
		const WorkflowMenuHeader = cx({
			WorkflowMenuHeader: true,
			WorkflowMenuHeaderVisible: props.loading
		});

		return (
			<div className={WorkflowMenuHeader}>
				{!props.loading && (
					<BCButton
						type="link"
						onClick={onClickSynergyMenuButton}
						size="large"
						icon={<IconWaffle />}
					/>
				)}
				<div className={Styles.WorkflowMenuTitle}>{getPanelTitleValue()}</div>
				<div className={Styles.WorkFlowMenuEvents}>
					<div className={Styles.Actions}>
						<div className={Styles.ButtonClose}>
							{' '}
							<IconCloseWindow onClick={onCancelClick} />
						</div>
					</div>
				</div>
			</div>
		);
	};

	const iframeContainerStyle: React.CSSProperties = {
		width: props.leftMenuIsPinned ? 'calc(100% - 380px)' : '100vw'
	};

	return (
		<BCModal
			className={Styles.eBA6IntegrationModalContainer}
			width="100%"
			visible
			handleOk={onOkClick}
			handleCancel={onCancelClick}
			okText={''}
			cancelText={''}
			footer={[<></>]}
		>
			<BCLoading show={props.loading}>
				<div
					style={iframeContainerStyle}
					className={Styles.iframeContainer}
				>
					{getPanelHeader()}
					{props.url !== '' && (
						<iframe
							allow="geolocation"
							className={Styles.iframeStyle}
							id="eBA6Iframe"
							src={props.url}
							width="100%"
							frameBorder="0"
							height="100%"
							onLoad={iframeOnLoad}
						/>
					)}
				</div>
			</BCLoading>
		</BCModal>
	);
};

export default LeftMenuEBA6Integration;
